import { HelmetProvider } from "react-helmet-async";
import type { ReactNode } from "react";

// Create a custom HelmetProvider that works with react-snap
interface HelmetProviderProps {
  children: ReactNode;
}

const CustomHelmetProvider = ({ children }: HelmetProviderProps) => {
  // Create a helmet context that can be used by react-snap
  const helmetContext = {};

  return <HelmetProvider context={helmetContext}>{children}</HelmetProvider>;
};

export default CustomHelmetProvider;
